import { endOfDay, endOfYear, startOfMonth, startOfYear, subYears } from 'date-fns';
import { PickerPresetType } from './DateRangeFilter';

const YEAR_TO_DATE: PickerPresetType = {
    label: 'YTD',
    startDate: startOfYear(new Date()),
    endDate: endOfDay(new Date()),
};

const MONTH_TO_DATE: PickerPresetType = {
    label: 'MTD',
    startDate: startOfMonth(new Date()),
    endDate: endOfDay(new Date()),
};

const PREVIOUS_YEAR: PickerPresetType = {
    label: 'Previous year',
    startDate: startOfYear(subYears(new Date(), 1)),
    endDate: endOfYear(subYears(new Date(), 1)),
};

export const DEFAULT_DATE_RANGE_PRESETS = [YEAR_TO_DATE, MONTH_TO_DATE, PREVIOUS_YEAR];
